<ion-app>
  <ion-split-pane *ngIf="!onlyLanding" when="(max-width: 0px)" content-id="main-content" contentId="main-content">
    <!-- <app-header [class.scrolling]="scrollEventsService.headerVisible === true"></app-header> -->
    <ion-menu content-id="main-content" contentId="main-content" menu-id="sidebar" menuId="sidebar" side="end" type="overlay">
      <ion-content>
        <nav>
          <div class="menu-header">
            <div *ngIf="tenantLogo$ | async as tenantLogo" class="brand-logo">
              <img [src]="tenantLogo" alt="" />
            </div>
            <ion-menu-toggle class="close-menu">
              <ion-icon name="close-sharp"></ion-icon>
            </ion-menu-toggle>
          </div>

          <ion-list *ngIf="enabledModules$ | async as modules" lines="none" class="main-sections">
            <ion-menu-toggle *ngIf="modules.includes('STORES')" auto-hide="false">
              <ion-item [languageRouter]="['tiendas']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.SHOPS' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item
                [languageRouter]="hasOnlyRestoration ? ['restaurantes'] : ['ocio-y-restaurantes']"
                lines="none"
                detail="false"
                routerLinkActive="selected"
              >
                <ion-label>{{ (hasOnlyRestoration ? 'FOOTER.RESTORATION' : 'FOOTER.LEISURE') | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="tenantHasCinema && modules.includes('CINEMA')" auto-hide="false">
              <ion-item [languageRouter]="['cartelera-de-cine']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.CINEMA' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="modules.includes('PROMOTIONS')" auto-hide="false">
              <ion-item [languageRouter]="['promociones']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.PROMOTIONS' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="modules.includes('AGENDA')" auto-hide="false">
              <ion-item [languageRouter]="['agenda']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.AGENDA' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="modules.includes('BLOG')" auto-hide="false">
              <ion-item href="{{ blogLink }}" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.BLOG' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item [languageRouter]="['planos']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.MAPS' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="(data$ | async)?.virtualTourUrl as virtualTourUrl" auto-hide="false">
              <ion-item [href]="virtualTourUrl" target="_blank" lines="none" detail="false">
                <ion-label>{{ 'SECTIONS.VIRTUAL_TOUR' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="modules.includes('SCHEDULE')" auto-hide="false">
              <ion-item [languageRouter]="['horarios']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.SCHEDULES' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="modules.includes('SERVICES')" auto-hide="false">
              <ion-item [languageRouter]="['servicios']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.SERVICES' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle *ngIf="iframe$ | async as iframe" auto-hide="false">
              <ion-item [routerLink]="landingUrl" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ iframeTitle }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

          <ion-list lines="none" class="sub-sections">
            <ion-item class="title">
              <ion-label>
                {{ 'SECTIONS.THE_MALL' | translate }}
              </ion-label>
            </ion-item>

            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" [languageRouter]="['el-centro']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label *ngIf="publicName$ | async as publicName">{{
                  'SECTIONS.ABOUT' | translate : { tenantName: publicName }
                }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item
                routerDirection="root"
                [languageRouter]="['tu-negocio-aqui']"
                lines="none"
                detail="false"
                routerLinkActive="selected"
              >
                <ion-label>{{ 'SECTIONS.YOUR_BUSINESS' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" [languageRouter]="['como-llegar']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.DIRECTIONS' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" [languageRouter]="['compromiso']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.COMMITMENT' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item
                routerDirection="root"
                [languageRouter]="['sostenibilidad']"
                lines="none"
                detail="false"
                routerLinkActive="selected"
              >
                <ion-label>{{ 'SECTIONS.SUSTAINABILITY' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" [languageRouter]="['contacto']" lines="none" detail="false" routerLinkActive="selected">
                <ion-label>{{ 'SECTIONS.CONTACT' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>
          <ng-container *ngIf="data$ | async as data">
            <div *ngIf="data.socialMedia" class="social-networks">
              <ion-button
                *ngIf="data.socialMedia.instagram"
                [href]="data.socialMedia.instagram"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <ion-icon name="logo-instagram"></ion-icon>
              </ion-button>
              <ion-button
                *ngIf="data.socialMedia.pinterest"
                [href]="data.socialMedia.pinterest"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <ion-icon name="logo-pinterest"></ion-icon>
              </ion-button>
              <ion-button
                *ngIf="data.socialMedia.facebook"
                [href]="data.socialMedia.facebook"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <ion-icon name="logo-facebook"></ion-icon>
              </ion-button>
              <ion-button
                *ngIf="data.socialMedia.twitter"
                [href]="data.socialMedia.twitter"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <ion-icon name="logo-twitter"></ion-icon>
              </ion-button>
              <ion-button
                *ngIf="data.socialMedia.tripadvisor"
                [href]="data.socialMedia.tripadvisor"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <i class="icon-tripadvisor"></i>
              </ion-button>
              <ion-button
                *ngIf="data.socialMedia.youtube"
                [href]="data.socialMedia.youtube"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <ion-icon name="logo-youtube"></ion-icon>
              </ion-button>
              <ion-button
                *ngIf="data.socialMedia.whatsapp"
                [href]="data.socialMedia.whatsapp"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <ion-icon name="logo-whatsapp"></ion-icon>
              </ion-button>
              <ion-button
                *ngIf="data.socialMedia.tiktok"
                [href]="data.socialMedia.tiktok"
                target="_blank"
                size="small"
                color="primary"
                fill="clear"
              >
                <ion-icon name="logo-tiktok"></ion-icon>
              </ion-button>
            </div>
          </ng-container>
        </nav>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content" animated="false" *ngIf="!warMode"></ion-router-outlet>
    <ion-content id="main-content" *ngIf="warMode" class="war-mode">
      <div class="container">
        <div class="claim">
          <img src="../assets/images/common/404icon.svg" alt="" />
          <h4 class="text">Modo mantenimiento.</h4>
          <h5>Nuestro sitio esta actualmente bajo mantenimiento. Disculpe las molestias.</h5>
        </div>
      </div>
    </ion-content>
  </ion-split-pane>

  <ion-content id="main-content" *ngIf="onlyLanding" class="war-mode">
    <div class="container">
      <div class="claim" *ngIf="metadata">
        <img [src]="tenantLogo$ | async" class="logo-soon" />

        <h4 class="text">{{ 'GLOBALS.SOON_WEB' | translate }}</h4>
        <div>
          <span><br>{{ 'GLOBALS.COMERCIAL' | translate }} {{ metadata.name }}</span>
          <span><br>{{ metadata.address_1 }}</span>
          <span><br>{{ metadata.address_2 }}</span>
          <span><br>
            {{ 'GLOBALS.PHONE_ABBREVIATION' | translate }}: <a [href]="'tel:' + metadata.phone">{{ metadata.phone }}</a>
          </span>
          <span><br>
            {{ 'FIELDS.EMAIL' | translate }}: <a [href]="'mailto:' + metadata.clientEmail">{{ metadata.clientEmail }}</a>
          </span>
        </div>
      </div>
    </div>
  </ion-content>

  <!-- <div class="cookies-advice" *ngIf="!cookiesOpen">
    <div class="cookies-window">
      <div [innerHTML]="cookies"></div>
      <ion-button (click)="closeCookies('accepted')" fill="clear">{{ 'COOKIES.ACCEPT' | translate }}</ion-button>
      <ion-button (click)="closeCookies('custom')" fill="clear">{{ 'COOKIES.CONFIG' | translate }}</ion-button>
    </div>

  </div> -->
</ion-app>
